module.exports = __webpack_public_path__ + "static/media/no_logo.12f6e6b0.png";